/** Late-game storm surge — extra damage when too many players remain in a small zone. */
export type StormSurgeTick = {
  damage: number;
  showBanner: boolean;
};

const MAX_ALIVE_BY_PHASE: Record<number, number> = {
  4: 14,
  5: 9,
  6: 5,
};

const SURGE_DAMAGE = 12;
const TICK_INTERVAL = 2.2;

export class FpsStormSurge {
  private tickAcc = 0;
  private bannerShownForPhase = 0;

  resetForMatch(): void {
    this.tickAcc = 0;
    this.bannerShownForPhase = 0;
  }

  /**
   * Returns surge damage when `alive` exceeds the cap for `phase` (4+).
   * `outsideSafeZone` — surge primarily punishes players outside the safe circle.
   */
  update(
    dt: number,
    phase: number,
    alive: number,
    outsideSafeZone: boolean,
  ): StormSurgeTick {
    if (phase < 4 || alive <= 0) {
      this.tickAcc = 0;
      return { damage: 0, showBanner: false };
    }

    const cap = MAX_ALIVE_BY_PHASE[phase] ?? MAX_ALIVE_BY_PHASE[6]!;
    if (alive <= cap) {
      this.tickAcc = 0;
      return { damage: 0, showBanner: false };
    }

    let showBanner = false;
    if (this.bannerShownForPhase !== phase) {
      this.bannerShownForPhase = phase;
      showBanner = true;
    }

    if (!outsideSafeZone) {
      return { damage: 0, showBanner };
    }

    this.tickAcc += dt;
    if (this.tickAcc < TICK_INTERVAL) {
      return { damage: 0, showBanner };
    }
    this.tickAcc = 0;
    const overflow = alive - cap;
    const scale = 1 + Math.min(3, overflow * 0.15);
    return { damage: SURGE_DAMAGE * scale, showBanner };
  }
}
